module.exports = __webpack_public_path__ + "static/assets/6bb9f0ef229b44465f9476e6ebb50ed9.svg";